
class Tip_model {
    constructor () {
        let div_com = document.createElement('div');
        div_com.id = 'tip_model_mask';
        div_com.style.zIndex = 100;
        div_com.style.position = 'fixed';
        div_com.style.top = 0;
        div_com.style.left = 0;
        div_com.style.bottom = 0;
        div_com.style.right = 0;
        div_com.style.display = 'none';
        div_com.style.justifyContent = 'center';
        div_com.style.alignItems = 'center';
        div_com.innerHTML = `<div id="tip_model" style="white-space:normal;word-break:break-word;max-width: 6rem;padding: 0.2rem 0.4rem;line-height: 0.56rem;text-align: center;border-radius: 0.12rem;font-size: 0.36rem;background-color: #333;color: #fff;"></div>`;
        document.body.appendChild(div_com);

        this.mask = document.getElementById('tip_model_mask');
        this.model = document.getElementById('tip_model');
    }
    tip_show (word_arr, show_time = 800) {
        let tip_word = '';
        if(typeof word_arr === 'string') {
            tip_word += `<div>${word_arr}</div>`;

        } else {
            for (let i = 0; i < word_arr.length; i++) {
                tip_word += `<div>${word_arr[i]}</div>`;
            }
        }
        this.model.innerHTML = tip_word;
        this.mask.style.display = 'flex';
        setTimeout(() =>{
            this.model.style.transition = 'all 0.3s';
            this.model.style.opacity = 0;
            setTimeout(() => {
                this.mask.style.display = 'none';
                this.model.style.transition = 'all 0s';
                this.model.style.opacity = 1;
            }, 300);
        }, show_time);
    }
}

module.exports = {
    Tip_model
};




// WEBPACK FOOTER //
// ./module/tip_model.js